import type { ExcelColumnMapping } from './types';
import type { PhieuThu } from '@/types/schemas';
import { formatDate } from '@/lib/formatUtils';

export type PhieuThuExportRow = PhieuThu & {
  username2?: string;
  datetime2?: string;
};

export const PHIEU_THU_COLUMNS: ExcelColumnMapping<PhieuThuExportRow>[] = [
  { header: 'Trạng thái', width: 12, resolver: row => row.status ?? '' },
  { header: 'Số c/từ', width: 18, resolver: row => row.so_ct ?? '' },
  { header: 'Ngày c/từ', width: 14, resolver: row => formatDate(row.ngay_ct ?? null) },
  { header: 'Mã đối tượng', width: 18, resolver: row => row.ma_kh_data?.customer_code ?? '' },
  { header: 'Tên đối tượng', width: 28, resolver: row => row.ma_kh_data?.customer_name ?? '' },
  { header: 'Diễn giải', width: 30, resolver: row => row.dien_giai ?? '' },
  { header: 'Tk nợ', width: 12, resolver: row => row.tk_data?.code ?? '' },
  { header: 'Tổng tiền', width: 18, resolver: row => Number(row.t_tien ?? 0) },
  { header: 'Ngoại tệ', width: 12, resolver: row => row.ma_nt_data?.ma_nt ?? '' },
  { header: 'Loại giao dịch', width: 16, resolver: row => row.ma_ngv ?? '' },
  { header: 'Người sửa', width: 18, resolver: row => row.username2 ?? '' },
  { header: 'Ngày sửa', width: 20, resolver: row => row.datetime2 ?? '' }
];
